import React from "react";
import { useMediaQuery } from "react-responsive"; // Import useMediaQuery
import "../css/grid.css";
import PatientCard from "../components/PatientCard";
import PatientCardSm from "../components/PatientCardSm";

const GridLayout = ({ data, handlePatientDetails, lastDataElementRef }) => {
  const lg = useMediaQuery({ query: "(min-width:635px)" });

  return (
    <div className="cu-patient-layout-main sm:gap-8 gap-2">
      {data?.map((item, i) =>
        lg ? (
          <PatientCard
            data={item}
            key={i}
            handlePatientDetails={handlePatientDetails}
            ref={data.length === i + 1 ? lastDataElementRef : null}
          />
        ) : (
          <PatientCardSm
            data={item}
            key={i}
            handlePatientDetails={handlePatientDetails}
            ref={data.length === i + 1 ? lastDataElementRef : null}
          />
        )
      )}
    </div>
  );
};

export default GridLayout;
